import { render, staticRenderFns } from "./SimpleCell.vue?vue&type=template&id=0bbe5f04&scoped=true&"
import script from "./SimpleCell.vue?vue&type=script&lang=js&"
export * from "./SimpleCell.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCell.vue?vue&type=style&index=0&id=0bbe5f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe5f04",
  null
  
)

export default component.exports